import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const appendAttentiveScript = (src) => {
    if (!src || document.querySelector(`script[src="${src}"]`)) {
        return
    }
    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.type = 'text/javascript'
    document.body.appendChild(script)
}

const AttentiveScript = () => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {attentive} = commerceAPI
    const {config} = attentive || {}

    var attentiveScriptTagURL = null
    var attentiveScriptLoadURL = null

    try {
        const jsonConfig = JSON.parse(config)
        if (jsonConfig) {
            attentiveScriptTagURL = jsonConfig.scriptTagURL
            attentiveScriptLoadURL = jsonConfig.scriptLoadURL
        }
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        // dtag.js is Attentive's on-site SDK and is what injects the Waitlist Notify Me CTA.
        appendAttentiveScript(attentiveScriptTagURL)
        appendAttentiveScript(attentiveScriptLoadURL)
    }, [attentiveScriptTagURL, attentiveScriptLoadURL])

    return null
}

export default AttentiveScript
